// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var MoreVertical = function MoreVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#morevertical-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 5.625a1.88 1.88 0 0 0 1.875-1.878A1.87 1.87 0 0 0 10 1.875a1.873 1.873 0 0 0-1.875 1.872v.012c0 1.034.839 1.866 1.875 1.866M10 11.875a1.88 1.88 0 0 0 1.875-1.878A1.87 1.87 0 0 0 10 8.125a1.873 1.873 0 0 0-1.875 1.872v.012c0 1.034.839 1.866 1.875 1.866M10 18.125a1.88 1.88 0 0 0 1.875-1.878A1.873 1.873 0 0 0 10 14.375a1.873 1.873 0 0 0-1.875 1.872v.012c0 1.034.839 1.866 1.875 1.866"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "morevertical-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 1.25v17.5H0V1.25z"
  }))));
};
